module.exports = __webpack_public_path__ + "static/media/sh-hl.074d05a8.svg";